<template>
    <div class="flex w-full">
        <slot
            :content="content"
            :isLoading="isLoading"
        >
            <Wiki
                :isLoading="isLoading"
                :content="content"
            />
        </slot>
    </div>
</template>

<script>
    import { wikiService } from '@core/services/wiki/WikiService';
    import { links, routeNames } from '@app/router';
    import { errorGuard } from '@app/utils';
    import XJackpotMixin from '@modules/wiki/components/XJackpotMixin';
    import Wiki from './components/Wiki';

    const DEFAULT_OFFSET = -80;

    export default {
        name: 'WikiContainer',
        mixins: [XJackpotMixin],
        data() {
            return {
                content: '',
                isLoading: false,
            };
        },
        async created() {
            await this.fetchPage();
            this.scrollToPosition();
        },
        mounted() {
            if (this.$route.params.pageSlug === 'xjackpot') {
                this.setupCounter();
            }
        },
        watch: {
            async $route() {
                await this.fetchPage();
                this.scrollToPosition();
            }
        },
        computed: {
            pageSlug() {
                return this.$route.name === routeNames.promotionsInfo
                    ? this.$route.path.replace('/', '')
                    : this.$route.params.pageSlug;
            }
        },
        methods: {
            async fetchPage() {
                this.isLoading = true;
                await errorGuard({
                    action: async () => {
                        this.content = await wikiService.getPage(this.pageSlug);
                    },
                    onError: () => {
                        this.$router.push(links.page_404);
                    },
                });
                this.isLoading = false;
            },
            // IMPORTANT: scrollTo uses same selectors as css, we use '#' (prefix for id)
            scrollToPosition() {
                if (this.$route.hash) {
                    this.$scrollTo(this.$route.hash, { offset: DEFAULT_OFFSET });
                }
            },
            async findXJackpotElements() {
                await this.$nextTick();
                return [
                    document.querySelector('.xjackpot-imgbox'),
                    document.querySelector('.xjackpot-amount-content'),
                ];
            }
        },
        components: {
            Wiki,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/wiki/WikiContainer.vue